// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMobileV1SetSettingsRequest,
  TPublicMobileV1SetSettingsModel,
  IMappers,
  TPublicMobileV1SetSettingsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IMessagesListSchema } from '../../../entities/messages_list/MessagesListSchema';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMobileV1SetSettingsModel(
  parameters: TPublicMobileV1SetSettingsRequest,
): TPublicMobileV1SetSettingsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/mobile/v1/set-settings/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicMobileV1SetSettingsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicMobileV1SetSettingsRequest;
}

export async function fetchPublicMobileV1SetSettings<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMobileV1SetSettingsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMobileV1SetSettingsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMobileV1SetSettingsModel(parameters),
    config,
  )) as FetchResponse<TPublicMobileV1SetSettingsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesListSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMobileV1SetSettingsResponse>;
}
